module.exports = __webpack_public_path__ + "img/Autocolant TCHE_150mm x 180mm-01.95b29d96.jpg";